module.exports = __webpack_public_path__ + "img/chad.ae0b0e49.svg";